module.exports = __webpack_public_path__ + "img/a03.646fd103.png";